module.exports = __webpack_public_path__ + "img/union-img.038b7cf9.png";